/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespShippingReturns_shipment = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_shipment">;
    readonly " $refType": "PdpRespShippingReturns_shipment";
};
export type PdpRespShippingReturns_shipment$data = PdpRespShippingReturns_shipment;
export type PdpRespShippingReturns_shipment$key = {
    readonly " $data"?: PdpRespShippingReturns_shipment$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_shipment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_shipment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipment"
    }
  ],
  "type": "Shipment",
  "abstractKey": null
};
(node as any).hash = '068d48c4fa1782a753ba69b4f347427d';
export default node;
